
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ServiceCodesQuantityNumberField extends Vue {
  @Prop(Number) public value: number;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  @Watch('value', { immediate: true })
  private watchValue(value: number) {
    // console.debug('watchValue', value);
    this.fieldValue = String(value);
  }

  @Watch('fieldValue')
  private watchFieldValue(fieldValue: string | null) {
    // console.debug('watchFieldValue', fieldValue);
    this.$emit('input', Number(fieldValue) || this.min);
  }

  public _clearFieldValue(rewriteValue: string) {
    this.fieldValue = null;
    this.$nextTick(() => {
      this.fieldValue = rewriteValue;
    });
  }

  public min = 1;
  public max = 9999;
  public fieldValue: string | null = String(this.min);
  public isError = false;

  public handleInput(value: string) {
    // console.debug('input', value);
    const valueNum = Number(value);
    const valueInt = parseInt(value);
    const valueIntStr = String(valueInt);
    let rewriteValue = '';
    if (!value || valueNum < this.min || valueNum !== valueInt) {
      rewriteValue = String(this.min);
    } else if (valueNum > this.max) {
      rewriteValue = String(this.max);
    } else if (valueIntStr !== value) {
      rewriteValue = valueIntStr;
    }
    if (rewriteValue) {
      this.blinkError();
      this._clearFieldValue(rewriteValue);
    }
  }

  public blinkError() {
    this.isError = true;
    this.$nextTick(() => {
      setTimeout(() => {
        this.isError = false;
      }, 150);
    });
  }

  public handleKeypress(event: KeyboardEvent) {
    if (!/\d+/.test(event.key)) {
      this.blinkError();
      event.preventDefault();
    }
  }
}
